import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateLinkForm } from '~/components/forms/LinkForm';
import { CategoryBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppCreateLinkPageProps = {
  appId: string;
  parentCategoryId?: string;
};

export const AppCreateLinkPage: React.FC<IAppCreateLinkPageProps> = (props) => {
  const { appId, parentCategoryId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('AppCreateLinkPage.seo.title')}</title>
      </Helmet>

      <CategoryBreadcrumbs appId={appId} categoryId={parentCategoryId} />

      <CreateLinkForm
        appId={appId}
        parentCategoryId={parentCategoryId}
        onSuccess={(createdLink) =>
          navigate(
            createdLink.parentId
              ? `/apps/${appId}/categories/${createdLink.parentId}`
              : `/apps/${appId}/categories`,
          )
        }
        cancelUrl={
          parentCategoryId
            ? `/apps/${appId}/categories/${parentCategoryId}`
            : `/apps/${appId}/categories`
        }
      />
    </>
  );
};
